import { render, staticRenderFns } from "./wxLoginComponent.vue?vue&type=template&id=5a14c03e&scoped=true"
import script from "./wxLoginComponent.vue?vue&type=script&lang=js"
export * from "./wxLoginComponent.vue?vue&type=script&lang=js"
import style0 from "./wxLoginComponent.vue?vue&type=style&index=0&id=5a14c03e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a14c03e",
  null
  
)

export default component.exports